<template>
  <MenuCard title="Effects" tooltip="Add special effects to the model">
      <v-card-text class="">
        <div>
          <Row title="Effect">
          <v-select class="mt-2" @input="onChangeEffect" hide-details :items="effects" v-model="currentEffect" dense outlined></v-select>
          </Row>
          <div v-if="currentEffect != 'No Effect'">
            <v-list-item class="pa-0 ma-0" v-for="(value, name) in effectSettings" :key="name">
              <Row :title="name">
              <NumberController v-if="name != 'color' && (typeof(value) == 'number' || typeof(value) == 'string')" @input="updateEffectSettings($event, name)" v-model="effectSettings[name]" step=0.01 precision=5></NumberController>
              </Row>

              <!-- <v-text-field v-if="name != 'color' && (typeof(value) == 'number' || typeof(value) == 'string')" @input="updateEffectSettings($event, name)" step=0.1 :value="value" type="number" hide-details :label="name"></v-text-field> -->

              <!-- <v-text-field v-if="typeof(value) == 'number' || typeof(value) == 'string'" step=0.1 hide-details :append-icon="isAlreadyDefaultUniform(name) ? '' : 'mdi-restore'" @click:append="(e) => restoreUniformDefault(name, e)" @input="updateChange" v-model="value" :label="name" :value="value" type="number"></v-text-field> -->

              <ColorPicker v-if="name == 'color'" @input="updateEffectSettings($event, name)" value="#000000"></ColorPicker>
            </v-list-item>
          </div>
        </div>
      </v-card-text>
  </MenuCard>
</template>

<script>
import MenuCard from './MenuCard.vue'
import { AvailableEffects, EffectsNames } from '../shaders/AvailableEffects.js'
//import { Color } from 'three';
import ColorPicker from './ColorPicker.vue'
import Row from './Row.vue'
import NumberController from './NumberController.vue'

  export default {
    name: 'EffectsMenu',
    components: {
        MenuCard,
        ColorPicker,
        Row,
        NumberController,
    },
    methods: {
        updateEffectSettings(e, name) {
            //console.log(e, name);
            this.effectSettings[name] = e;
            this.$store.commit("setEffectSettings", this.effectSettings);
        },
        onChangeEffect(newValue) {
            this.effectSettings = {...this.getSettings(newValue)};
            this.$store.commit("setEffectSettings", this.effectSettings);
        },
        getSettings(effectName) {
            if (this.currentEffect == "No Effect") {
                return {};
            }

            var found = AvailableEffects.find((elm) => {
                return elm.title == [effectName];
            });

            //console.log(found.settings);
            return found.settings;
        },
    },
    
    mounted() {
    },

    data: function () {
        let effects = ["No Effect"]
        effects.push(...EffectsNames);
        return { 
            effects: effects,
            effectSettings: {},
        };
    },

    props: [],
    watch: {
    },

    computed: {
        currentSettings: {
            get() {
                return this.$store.state.currentSettings;
            },
            set(value) {
                this.$store.commit('setEffectSettings', value);
            },
            //if (this.currentEffect == "No Effect") {
            //    return {};
            //}

            //var found = AvailableEffects.find((elm) => {
            //    return elm.title == [this.currentEffect];
            //});

            //console.log(found.settings);
            //return found.settings;
        },
        currentEffect: {
            get() {
                return this.$store.state.currentEffect;
            },
            set(value) {
                this.$store.commit('setCurrentEffect', value);
            },
        },
    },
  }
</script>
